import React from 'react';
import { getLang, jc } from 'utils';
import { Typography } from 'fronton-react';
import { DeliveryOptionIcon } from './delivery-option-icon';
import { delivOpt, delivOptIconCntr, delivOptTextContent } from './delivery-option.styles';
import { getDeliveryTermText } from '../../utils/get-delivery-term-text';

export type DeliveryOptionProps = {
  type: 'SELF' | 'PICKUP' | 'DELIVERY' | 'HOME_DELIVERY' | 'POINT' | 'PICKUP_POINT';
  title: string;
  price: string;
  maxStockAvailable?: number;
} & React.HTMLAttributes<HTMLElement>;

export const DeliveryOption: React.FC<DeliveryOptionProps> = ({ type, title, price, className }) => {
  const lang = getLang();
  return (
    <div className={jc(delivOpt, className || '')}>
      <div className={delivOptIconCntr}>
        <DeliveryOptionIcon type={type} color="text-primary" />
      </div>
      <div className={delivOptTextContent}>
        <Typography variant="s" size="body_long" color="text-primary">
          {getDeliveryTermText(title, lang)}
        </Typography>
        <Typography variant="s" size="body_long" color="text-primary">
          {price}
        </Typography>
      </div>
    </div>
  );
};
